import Vue from 'vue';

// Expose to Vue
window.Vue = Vue;

// This shouldn't be required here.
Vue.config.devtools = true;
